var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerIconNailshop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.788 10h3.063V6.25a.757.757 0 0 0-.766-.75H9.553a.757.757 0 0 0-.765.75zm-1.634 3.06.664 3.9 3.487-4.335H7.532a.377.377 0 0 0-.378.436zm5.952-1.56H7.531c-.945 0-1.666.832-1.51 1.747l1.127 6.626c.062.36.381.627.755.627h4.83a.763.763 0 0 0 .756-.627l1.129-6.626c.155-.915-.564-1.747-1.512-1.747zm4.596 8.999h1.533a.758.758 0 0 0 .765-.75v-4.5h-3.063v4.5c0 .416.342.75.765.75zm0-5.25h1.533v-3.748h-1.533zM18.085 10l-.766-3h2.298l-.766 3z",
    clipRule: "evenodd"
  })));
}
export default SvgMarkerIconNailshop;